import React from "react";

import { ManOutlined, SearchOutlined, WomanOutlined } from "@ant-design/icons";
import medicineImg from "@/assets/images/study-types/medicine-256x256.webp";
import surveyImg from "@/assets/images/study-types/survey-256x256.webp";
import diabetesImg from "@/assets/images/disease-grid/diabetes-512x512.webp";

export const DistanceOptions: { label: string; value: number | "all" }[] = [
    { label: "10", value: 16093 },
    { label: "25", value: 40233 },
    { label: "50", value: 80467 },
    { label: "100", value: 160934 },
    { label: "Anywhere", value: "all" },
]; // Miles in meters

export const AgeOptions = [
    { label: "<17", value: "CHILD" },
    { label: "18-65", value: "ADULT" },
    { label: "65+", value: "OLDER_ADULT" },
];

export const GenderOptions = [
    {
        icon: <WomanOutlined />,
        label: "Female",
        value: "FEMALE",
    },
    {
        icon: <ManOutlined />,
        label: "Male",
        value: "MALE",
    },
];

export const StudyTypeOptions = [
    {
        id: "medicationStudies",
        label: "Medication",
        subLabel: "Studies where participants are administered a test drug.",
        example: "example: Ibuprofen, Aspirin",
        image: <img alt="" src={medicineImg} className="responsive-image" />,
        value: "medicationStudies",
        color: "magenta",
    },
    {
        id: "studiesWithDevice",
        label: "Device",
        subLabel: "Studies where participants wear or use a medical device.",
        example: "example: Knee brace",
        image: <img alt="" src={diabetesImg} className="responsive-image" />,
        value: "studiesWithDevice",
        color: "gold",
    },

    {
        id: "observationalStudies",
        label: "Survey",
        subLabel: "Studies where participants have tests or symptoms recorded. No drug is \n given or device used.",
        example: "",
        image: <img alt="" src={surveyImg} className="responsive-image" />,
        value: "observationalStudies",
        color: "cyan",
    },
    {
        id: "someExperience",
        label: "I’m just looking",
        subLabel: "I don't know yet! I’m looking for all kinds of studies.",
        example: "",
        image: <SearchOutlined className="responsive-image" />,
        value: "someExperience",
        color: "purple",
    },
];
